import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { Typography, Box } from '@mui/material';
import { UtmCloseIcons } from '../../icons';
export default function RemarksModal({ onClose, open, data }) {
    const remarkText = data?.remarks || 'No remarks added'
    return (
        <React.Fragment>

            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiPaper-root': {
                        padding: '20px 14px',
                        width: '360px',
                        borderRadius: '7px'
                    }
                }}
            >
                <Box>
                    <Box sx={{ marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
                        <Box>
                            <Typography sx={{ color: '#101828', fontWeight: '500', fontSize: '18px', fontFamily: 'Neue Montreal' }}>Remarks</Typography>
                            <Typography sx={{ color: '#4A5565', fontWeight: '400', fontSize: '14px', fontFamily: 'Neue Montreal' }}>
                                Campaign Name: {data?.name || '-'}
                            </Typography>
                        </Box>
                        <UtmCloseIcons onClick={onClose} />
                    </Box>

                    <Box sx={{ background: '#F0F9FD', borderRadius: '10px', padding: '7px', display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                        <textarea readOnly value={remarkText} style={{ background: 'none', border: 'none', fontSize: '13px', fontWeight: '400', width: '100%', height: '100px' }}></textarea>
                    </Box>

                </Box>
            </Dialog>
        </React.Fragment>
    );
}
